import {
  getAuthenticationDisplaySummary,
} from './authentication-display';

type ShouldClearAuthenticationBagIdOnBagTypeChangeParams = {
  previousBagTypeName?: string;
  currentBagTypeName?: string;
  previousAuthenticationBagId?: number;
  currentAuthenticationBagId?: number;
};

export const shouldClearAuthenticationBagIdOnBagTypeChange = ({
  previousBagTypeName,
  currentBagTypeName,
  previousAuthenticationBagId,
  currentAuthenticationBagId,
}: ShouldClearAuthenticationBagIdOnBagTypeChangeParams) => {
  if (previousBagTypeName === currentBagTypeName) {
    return false;
  }

  return previousAuthenticationBagId === currentAuthenticationBagId;
};

type ShouldShowBoundAuthenticationSummaryParams = {
  authenticationBagId?: number;
  hasLocalBagId: boolean;
  hasZoneImages: boolean;
  hasAuthenticationTaskState: boolean;
};

export const shouldShowBoundAuthenticationSummary = ({
  authenticationBagId,
  hasLocalBagId,
  hasZoneImages,
  hasAuthenticationTaskState,
}: ShouldShowBoundAuthenticationSummaryParams) => {
  if (!authenticationBagId) {
    return false;
  }

  return !hasLocalBagId && !hasZoneImages && !hasAuthenticationTaskState;
};

type BoundAuthenticationSummaryParams = {
  latestTask?: {
    authenticationId?: string;
    certificateNo?: string;
    createdAt?: string;
  } | null;
  latestResult?: {
    verdict?: string | null;
    authenticityScore?: number | null;
    reviewStatus?: 'pending' | 'genuine' | 'fake' | null;
  } | null;
  detectionPoints?: Array<{
    labelId?: number | null;
    score?: number | null;
    referenceImages?: string[] | null;
    publicUrl?: string | null;
  }> | null;
};

export const getBoundAuthenticationSummary = ({
  latestTask,
  latestResult,
  detectionPoints,
}: BoundAuthenticationSummaryParams) => {
  const summary = getAuthenticationDisplaySummary({
    latestResult,
    detectionPoints,
  });

  return {
    displayNo: latestTask?.certificateNo || latestTask?.authenticationId || '',
    verdict: summary.displayVerdict,
    verdictKind: summary.displayVerdictKind,
    score: summary.displayScore,
    scoreKind: summary.displayScoreKind,
    mode: summary.mode,
    createdAt: latestTask?.createdAt || '',
  };
};
